import { trpc } from "../trpc";

export function useAgentsEntitlement() {
  const { data, isLoading, isError, error } = trpc.agent.entitlement.useQuery();
  return {
    enabled: Boolean(data?.enabled),
    isLoading,
    isError,
    error,
  };
}
